<template>
  <div class="input-group mt-2">
    <button class="btn btn-link custom-arrows" @click="changeWeek('previous')">
      <i class="far fa-arrow-alt-circle-left"></i>
    </button>
    <span class="input-group-text custom-weekof">week of</span>
    <select
      v-model="current"
      class="form-select custom-select"
      @change="changeWeek('select')"
    >
      <option v-for="(week, idx) of weeks" :key="idx">
        {{ week.short }}
      </option>
    </select>
    <button class="btn btn-link custom-arrows" @click="changeWeek('next')">
      <i class="far fa-arrow-alt-circle-right"></i>
    </button>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZSelect from '@/Components/ZElements/Select'
import moment from 'moment'
export default {
  name: 'week-selector',
  components: {
    ZSelect,
  },
  props: {
    weeks: {
      type: Array,
      default: [],
    },
    week: {
      type: String,
      default: '',
    },
    isCoach: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tempCurrent: null,
    }
  },
  computed: {
    ...mapGetters('usercardio', ['summary']),
    current: {
      get() {
        console.log('Week Selector - Week', this.tempCurrent)
        let _week = this.tempCurrent
        if (this.summary) {
          if (this.summary.week) {
            _week = this.summary.week.name
          } else if (this.week) {
            _week = this.week
          }
        } else if (this.week) {
          _week = this.week
        }
        return _week
      },
      set(value) {
        this.tempCurrent = value
      },
    },
  },
  methods: {
    ...mapActions('usercardio', ['setWeek']),
    changeWeek(dir) {
      this.$nextTick(() => {
        let data = {
          isDir: dir !== 'select' ? true : false,
          week: dir === 'select' ? this.tempCurrent : this.current,
          increment: dir === 'previous' ? -1 : dir === 'next' ? 1 : 0,
          isCoach: this.isCoach,
        }
        console.log('Week Selector - Change Week', {
          data: data,
          dir: dir,
          current: this.current,
          weeks: this.weeks,
        })
        this.setWeek(data)
        this.tempCurrent = this.summary.week.name
        console.log('Week Selector - New Week', this.summary)
        this.$emit('change', this.current)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-select {
  max-width: 100px;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.custom-weekof {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
.form-select:focus {
  box-shadow: none !important;
}
.custom-arrows {
  padding: 5px;
  i {
    font-size: 1.6em;
  }
}
.custom-arrows:focus {
  box-shadow: none !important;
}
</style>
